import { render, staticRenderFns } from "./BotonMontoTotalConceptos.vue?vue&type=template&id=2ffb41d2"
import script from "./BotonMontoTotalConceptos.vue?vue&type=script&lang=js"
export * from "./BotonMontoTotalConceptos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports